<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router/composables'

const props = defineProps({
  to: {
    type: [String, Object],
    required: true
  },
  disabled: {
    type: Boolean,
    description: 'removes the link'
  }
})

const route = useRoute()

const tenantName = computed(() => {
  return route?.params?.tenantName
})

const coercePath = path => {
  if (!tenantName.value) {
    return path
  }
  path = path.startsWith('/') ? path : `/${path}`
  return path.startsWith(`/${tenantName.value}`) ? path : `/${tenantName.value}${path}`
}

const to = computed(() => {
  if (typeof props.to === 'string') {
    return coercePath(props.to)
  } else if (typeof props.to === 'object' && props.to.path) {
    return {
      ...props.to,
      path: coercePath(props.to.path)
    }
  }
  return props.to
})
</script>

<template>
  <router-link v-bind="{ ...$attrs, to: to }" v-on="$listeners" :class="{ 'disabled-link': disabled }">
    <slot />
  </router-link>
</template>

<style lang="scss" scoped>
.disabled-link {
  pointer-events: none;
  cursor: default;
}
</style>
